import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "related-zone" }

import { withDefaults, ref } from 'vue';
import { XrkTable, XrkTableProps, useTableColumn } from 'xrk-components';
import { formatter } from '@/utils';
import { zonesList } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'related-zone',
  props: {
    row: {}
  },
  setup(__props: any) {

const props = __props;
const xrkTableRef = ref();
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [],
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      label: '编号ID',
      prop: 'zoneCode'
    }),
    useTableColumn({
      label: '专区名称',
      prop: 'title'
    }),
    useTableColumn({
      label: '项目名称',
      prop: 'projectName'
    }),
    useTableColumn({
      label: '关联项目时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    })
  ]
});

const getListAjax = async params => {
  try {
    const restParams = {
      ...params,
      id: props.row?.id,
      hasForm: 1
    };

    const res = await zonesList(restParams);

    return res;
  } catch (error) {
    console.log(error);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})